import { render, staticRenderFns } from "./bottom-footer.vue?vue&type=template&id=0feb1d0d&scoped=true&"
import script from "./bottom-footer.vue?vue&type=script&lang=ts&"
export * from "./bottom-footer.vue?vue&type=script&lang=ts&"
import style0 from "./bottom-footer.vue?vue&type=style&index=0&id=0feb1d0d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0feb1d0d",
  null
  
)

export default component.exports